module.exports = __webpack_public_path__ + "static/media/steve.81560c95.jpg";